var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniswapUniLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.15 0C32.4089 0 46.4 13.9911 46.4 31.25V46.4H0V0H15.15ZM15.15 10H10V36.4H36.4V31.25C36.4 19.6313 27.0754 10.1905 15.5014 10.0028L15.15 10Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6 46.4001V23.2001C53.6 10.3871 63.987 0.000139427 76.8 0.000139427C89.613 0.000139427 100 10.3871 100 23.2001C100 36.0132 89.613 46.4001 76.8 46.4001H53.6ZM63.6 36.4001H76.8C84.0902 36.4001 90 30.4903 90 23.2001C90 15.91 84.0902 10.0001 76.8 10.0001C69.5098 10.0001 63.6 15.91 63.6 23.2001V36.4001Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 53.4998V74.2498C46.5 88.4711 34.9713 99.9998 20.75 99.9998H0V89.9998H20.75C29.4485 89.9998 36.5 82.9482 36.5 74.2498V53.4998H46.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8 100C63.987 100 53.6 89.613 53.6 76.8V53.6H76.8C89.613 53.6 100 63.987 100 76.8C100 89.613 89.613 100 76.8 100ZM76.8 90C84.0902 90 90 84.0902 90 76.8C90 69.5098 84.0902 63.6 76.8 63.6H63.6V76.8C63.6 84.0173 69.3922 89.8817 76.5817 89.9982L76.8 90Z",
    fill: "#5A5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniswapUniLogo1);
export default __webpack_public_path__ + "static/media/uniswap-uni-logo 1.207c91d0d5669d8867cb1ab01e568c42.svg";
export { ForwardRef as ReactComponent };